module.exports = __webpack_public_path__ + "img/授权书.69832284.png";